<template>
    <tbody>
        <tr>
            <td>
                <span class="tx-table__cell muted">
                    <ui-timeago v-bind:timestamp="timestamp"/>
                </span>
            </td>
            <td>
                <ui-link class="tx-table__cell tx-table-cell-link-badge" v-bind:to="transactionRoute" >
                    <div class="tx-table__badge tx-table-cell-icon--out" v-if="type === 'TT_SELL'">
                        <div class="tx-table__badge--value" style="margin: 0 10px">
                            {{ $t('jetton_history.sell') }}
                        </div>
                    </div>
                    <div class="tx-table__badge tx-table-cell-icon--in" v-if="type === 'TT_BUY'">
                        <div class="tx-table__badge--value" style="margin: 0 10px">
                            {{ $t('jetton_history.buy') }}
                        </div>
                    </div>
                </ui-link>
            </td>
            <td>
                <span class="tx-table__cell">
                    <span class="jetton-history-pair jetton-history-pair__left">
                        <span class="ui-inline-jetton__value">
                            {{ $ton(from.amount, 0, !(from.amount < 0.01)) }}
                        </span>
                        <ui-link v-if="from?.symbol !== 'TON' && from?.address !== jettonAddress" v-bind:to="{ name: 'jetton', params: {address: from.address }}">
                            {{ from.symbol }}
                        </ui-link>
                        <template v-else>{{ from?.symbol }}</template>
                    </span>
                    <span class="tx-table-action-icon">
                        <arrow-right />
                    </span>
                    <span class="jetton-history-pair jetton-history-pair__right">
                        <span class="ui-inline-jetton__value">
                            {{ $ton(to.amount, 0, !(to.amount < 0.01)) }}
                        </span>
                        <ui-link v-if="to?.symbol !== 'TON' && to?.address !== jettonAddress" v-bind:to="{ name: 'jetton', params: {address: to.address }}">
                            {{ to.symbol }}
                        </ui-link>
                        <template v-else>{{ to?.symbol }}</template>
                    </span>
                </span>
            </td>
            <td>
                <span class="tx-table__cell tx-table__cell--align-right">
                    <ui-address v-bind:address="initiator" />
                </span>
            </td>
        </tr>
    </tbody>
</template>

<script>
import ArrowRight from '@img/icons/tonscan/arrow-small-right.svg?vue';
import { base64ToHex } from '~/utils';

export default {
    props: {
        hash: String,
        timestamp: Number,
        from: Object,
        to: Object,
        initiator: String,
        type: String,
        jettonAddress: String,
    },

    computed: {
        isOut() {
            return this.from?.address === this.jettonAddress;
        },
        left() {
            return this.isOut ? this.from : this.to;
        },
        right() {
            return this.isOut ? this.to : this.from;
        },
        transactionRoute() {
            return { name: 'tx', params: { hash: base64ToHex(this.hash) } };
        },
    },

    components: {
        ArrowRight,
    },
};
</script>

<style lang="scss">
.jetton-history-pair {
    text-transform: uppercase;
    &__left {
        color: var(--badge-red-color);

        a {
            color: var(--badge-red-color);
        }
    }
    &__right {
        color: var(--badge-green-color);

        a {
            color: var(--badge-green-color);
        }
    }
}
</style>
